const getAppSettings = () => ({
    data: {
        title: 'Portal de serviços',
        background: 'https://images.pexels.com/photos/1526/dark-blur-blurred-gradient.jpg',
        logo: process.env.PUBLIC_URL + '/img/logo-header.png',
        locales: {
            LABELS: {
                APPROVAL: {
                    APPROVE: 'Aprovar',
                    JUSTIFICATION: 'Justificativa',
                    REPROVE: 'Reprovar',
                    APPROVED: 'Aprovado',
                    PENDING: 'Pendente',
                    PENDING_SETTLEMENT: 'Aguardando resolução de pendências',
                    DISAPPROVED: 'Reprovado',
                    DRAFT: 'Rascunho',
                },
                COMMONS: {
                    ADITIONAL_DATA: 'Dados complementares',
                    ADDRESS: 'Endereço',
                    ADDRESS_NUMBER: 'Nº',
                    ATTENTION: 'Atenção',
                    BACK: 'Voltar',
                    CANCEL: 'Cancelar',
                    CHANGE_PASSWORD: 'Alterar Senha',
                    CHANGE_COMPANY: 'Trocar empresa',
                    CHANGE_THEME: 'Alternar Tema',
                    MANUAL: 'Manual de utilização',
                    CITY: 'Cidade',
                    COMPANY_DATA: 'Dados da empresa',
                    REQUESTER_DATA: 'Dados do solicitante',
                    COMPLEMENT: 'Complemento',
                    CONFIRM_PASSWORD: 'Confirmar senha',
                    CONTACT: 'Contato',
                    CPF_CNPJ: 'CPF/CNPJ',
                    CPF_CNPJ_EMAIL: 'CPF/CNPJ ou Email',
                    CURRENT_PASSWORD: 'Senha atual',
                    DESCRIPTION: 'Descrição',
                    DOCUMENT: 'Documento',
                    DOCUMENTATION: 'Documentação',
                    COMPANY: 'Empresa',
                    EMAIL: 'Email',
                    ENTER: 'Entrar',
                    EXIT: 'Sair',
                    FORGOT_MY_PASSWORD: 'Esqueci minha senha',
                    CHANGE_EMAIL: 'Alterar e-mail',
                    MAIN_DATA: 'Dados principais',
                    NAME: 'Nome',
                    NEIGHBORHOOD: 'Bairro',
                    NEW_PASSWORD: 'Nova senha',
                    PASSWORD: 'Senha',
                    NOTE: 'Observações',
                    PASSWORD_CHANGING: 'Atualização da senha',
                    PENDINGS_DAES: 'DAEs pendentes de pagamento',
                    PORTAL_ACCESS: 'Acesso ao portal',
                    REGISTER: 'Cadastrar',
                    SAVE: 'Salvar',
                    SEARCH: 'Pesquisar',
                    FILTER: 'Filtrar',
                    CLEAR: 'Limpar',
                    SEND: 'Enviar',
                    SELECT: 'Selecionar',
                    SENDER: 'Remetente',
                    SERVICES: 'Serviços',
                    SETTINGS: 'Configurações',
                    TITLE: 'Título',
                    USERS: 'Usuários',
                    ZIPCODE: 'CEP',
                    ACTIVE: 'Ativos',
                    INACTIVE: 'Inativos',
                },
                SERVICES: {
                    SEARCH_REQUEST: 'Buscar Solicitação',
                    SERVICE: 'Serviço',
                    DO_REQUEST: 'Solicitar',
                    REQUEST: 'Solicitação',
                    REQUESTS: 'Solicitações',
                    REQUEST_NUMBER: 'Nº solicitação',
                    FINALIZE_REQUEST: 'Finalizar Solicitação',
                    SEND_TO_SURVEYOR: 'Enviar para vistoriadora',
                    CONFIRM_CANCEL_REQUEST: 'Deseja cancelar essa solicitação?',
                    ACCESS_REQUEST_BTN: 'Acesse aqui a solicitação',
                    ACCESS_SERVIICES_BTN: 'Acessar serviço',
                    DOCDATE: 'Data',
                    DUEDATE: 'Vencimento',
                    DAE: 'DAE',
                    VALUE: 'Valor',
                    REGISTRATION: 'Inscrição Cadastral',
                    DIDNT_PRESENT_VEHICLE: 'Não apresentação do veículo em Data e Local programados',
                    SCHEDULE_BOARD: 'Quadro de horário',
                    ITINERARY: 'Itinerários',
                },
                COMPANY: {
                    DATA: 'Dados da empresa',
                    USERS: 'Usuários da empresa',
                    CRC: 'CRC',
                    CRC_TEXT: 'Certificado de Registro Cadastral',
                },
                VEHICLES: {
                    VEHICLES: 'Veículos',
                },
                INFRACTIONS: {
                    INFRACTIONS: 'Auto de infração',
                },
                LICENSES: {
                    LICENSES: 'Licenças',
                },
                LINES: {
                    LINES: 'Linhas',
                },
                LOGIN: {
                    LOGIN: 'Entrar',
                    PASSWORD_RECOVERING: 'Recuperação de senha',
                    PASSWORD_CHANGING: 'Alteração de senha',
                    PASSWORD_RECOVERING_OBS: 'Um email com o link para recuperação de senha será enviado para você.',
                    PASSWORD_RESET_OBS: 'Insira as informações abaixo para alteração de sua senha',
                    COMPANY_SELECT: 'Selecione a empresa',
                    COMPANY_SELECT_OBS: 'Seleciona abaixo a empresa que deseja administrar.',
                    NEW_PASSWORD: 'Nova senha',
                    CONFIRM_PASSWORD: 'Confirmar nova senha',
                    INFO_USERNAME: '*Digite o seu CPF/CNPJ de cadastro',
                },
                MENU: {
                    TABS: {
                        ATOZ: 'Letra A-Z',
                        LAST_ONES: 'Últimos publicados',
                        MOST_POPULAR: 'Os mais procurados',
                        IDENTIFICATION: 'Identificação',
                        DOCUMENTATION: 'Documentação',
                    },
                    SERVICES: {
                        LAST_ADDED: 'Últimos adicionados',
                        MOST_POPULAR: 'Mais procurados',
                        TITLE: 'Escolha o serviço desejado',
                        SEARCH_SERVICES: 'Busca de serviços',
                    },
                    SERVICES_IN_PROGRESS: {
                        TITLE: 'Solicitações em andamento',
                    },
                    LATEST_SERVICES: {
                        TITLE: 'Últimas Solicitações',
                    },
                    NEW_SERVICES: {
                        TITLE: 'Nova Solicitação',
                    },
                    NO_SERVICES: {
                        TITLE: 'Nenhuma solicitação enviada',
                    },
                },
                FORM: {
                    COMMENTS: 'Instruções de Preenchimento',
                    REQUIRED_DOCUMENTS: 'Documentos Obrigatórios',
                },
                WELCOMEINFO: {
                    TITLE: 'Bem-Vindo',
                },
                ALERTS: {
                    TITLE: 'Alertas',
                },
            },
            MESSAGES: {
                COMMONS: {
                    PASSWORD_DONT_MATCH: 'As senhas não são iguais',
                    PASSWORD_TOO_SHORT: 'Senha muito curta!',
                    PASSWORD_NEEDS_MIN_SIX_CHARS: 'A senha precisa ter no mínimo 6 caracteres.',
                    REQUIRED_FIELD: 'Campo obrigatório',
                    ADMIN_PENDING_APPROVAL_TITLE: 'Usuário pendente de aprovação',
                },
                LOGIN: {
                    MISSING_MANDATORY_INFO_LOGIN: 'Favor informar CPF / CNPJ e senha, informações obrigatórias',
                    MISSING_MANDATORY_INFO_RECOVERY: 'Favor informar o documento e email, informações obrigatórias',
                    MISSING_MANDATORY_INFO_CHANGE_PASS: 'Favor informar o documento e email, informações obrigatórias',
                    PASSWORD_DOESNT_MATCH: 'As informações de senha e confirmação de senha não são iguais.',
                    USER_NOT_FOUND: 'CPF / CNPJ ou senha não encontrado',
                    INVALID_EMAIL: 'Email inválido',
                    INVALID_CPF_CNPJ: 'CPF / CNPJ inválido',
                    COULD_NOT_CHANGE_PASSWORD: 'Não foi possível alterar sua senha.',
                    COULD_NOT_LOG_IN: 'Não foi possível autenticar o usuário.',
                    PASSWORD_DO_NOT_MATCH: 'As senhas não são compatíveis.',
                    PASSWORD_CHANGED: 'Sua senha foi alterada com successo.',
                    PASSWORD_CHANGED_ERROR: 'O link utilizado para alterar sua senha não é mais válido. Por favor, solicite novamente a alteração de senha e um novo link será enviado para o seu e-mail.',
                    RECOVERY_MESSAGE:
                        'Operação realizada com sucesso. A redefinição da senha foi enviada para o seu e-mail.',
                    RECOVERY_LINK_SENT: 'Um email com o link para a recuperação foi enviado para seu email.',
                },
                SERVICE: {
                    ADMIN_PENDING_APPROVAL: 'Após aprovação do administrador seus serviços serão exibidos aqui.',
                    FORMS: {
                        ERROS_SAVING_REVISION: 'Erro ao salvar revisão. Verifique os documentos e tente novamente.',
                        FILE_EXTENTION_NOT_ALLOWED: 'Extensão de arquivo não permitida',
                        FILE_MAX_SIZE: 'O tamanho do arquivo não pode ser maior que 10mb',
                        FILL_FLAGGED_FIELDS: 'O(s) campo(s) sinalizado(s) deve(m) ser preenchido(s)',
                        SUCCESSFUL_SAVED_INFOS: 'Informações salvas com sucesso',
                        MISSING_MANDATORY_INFOS:
                            'Favor informar os dados obrigatórios e os respectivos documentos para solicitar o serviço',
                        MISSING_CONTACTS_INFOS: 'As informações de Contatos e Sócios / Acionistas são obrigatórias.',
                        SUCCESSFUL_REQUEST:
                            'Solicitação realizada com sucesso. Você foi notificado por e-mail com as informações de acesso',
                        SUCCESSFUL_REQUEST_CHANGE_EMAIL:
                            'Solicitação realizada com sucesso. {numeroSolicitacao} Você será notificado por e-mail, após análise da solicitação pela agência',
                        SUCCESSFUL_SEND_REQUEST: 'Solicitação enviada com sucesso!',
                        SUCCESSFUL_SAVE_REQUEST: 'Solicitação salva com sucesso',
                        SUCCESSFUL_FINISHED_REQUEST: 'Solicitação finalizada com sucesso!',
                        SUCCESSFUL_CANCEL_REQUEST: 'Solicitação cancelada com sucesso!',
                        SUCCESSFUL_REPROVE_REQUEST: 'Solicitação reprovada com sucesso!',
                        SUCCESSFUL_APROVE_REQUEST: 'Solicitação aprovada com sucesso!',
                        SUCCESSFUL_SEND_SURVEY_REQUEST: 'Solicitação enviada para vistoriadora com sucesso!',
                        PROBLEM_SENDING_REQUEST: 'Problemas ao enviar solicitação. Tente novamente.',
                        PROBLEM_CANCEL_REQUEST: 'Problemas ao cancelar solicitação. Tente novamente.',
                        PROBLEM_REPROVE_REQUEST: 'Problemas ao reprovar solicitação. Tente novamente.',
                        PROBLEM_APROVE_REQUEST: 'Problemas ao aprovar solicitação. Tente novamente.',
                        CANCEL_REQUEST_CONFIRMATION: 'Deseja realmente cancelar essa solicitação?',
                        SUCCESSFUL_SAVE_REVISION: 'Revisão salva com sucesso.',
                        COMPANY_REGISTRATION_NOT_FOUND: 'Cadastro de empresa não localizado.',
                        PRINCIPAL_CONTACT_MISSING: 'Por favor, informe qual o contato principal.',
                        EMAIL_IGUAL_SOLICITADO: 'O novo e-mail deverá ser diferente do e-mail anterior',
                        CONTACT_INFO_MISSING:
                            'Antes de continuar, verifique as informações dos contatos. Alguns itens obrigatórios não foram preenchidos.',
                        PARTNER_INFO_MISSING:
                            'Antes de continuar, verifique as informações dos sócios/acionistas. Alguns itens obrigatórios não foram preenchidos.',
                        MISSING_MANDATORY_VEHICLES:
                            'Favor incluir um ou mais veículo(s) e seus respectivos documentos para salvar a solicitação.',
                        NO_VEHICLES_FOUND: 'Nenhum veículo encontrado para alteração ou exclusão.',
                        SURVEY_NO_VEHICLES_FOUND: 'Nenhum veículo encontrado para vistoria.',
                        ERROR_DAE_PAID: 'Não foi possível excluir o veículo. Problemas na verificação de DAE.',
                        DELETE_VEHICLE_ERROR_DAE_PAID:
                            'Não foi possível excluir o veículo. Pagamento de DAE já efetuado.',
                        DELETE_VEHICLE_NOT_ALLOWED_EMPTY:
                            'Não foi possível excluir o veículo. A solicitação deve possuir pelo menos um veículo.',
                        DOCUMENT_CRLV_REQUIRED: 'O documento CRLV é obrigatório.',
                        DOCUMENT_REPORT_REQUIRED: 'O documento laudo de vistoria é obrigatório.',
                        DOCUMENT_DESCRIPTION_REQUIRED:
                            'As informações dos documentos adicionais são obrigatórias. Certifique-se de ter inserido os arquivos e suas descrições.',
                        SELECT_REQUEST: 'Favor selecionar uma solicitação.',
                        NO_REQUEST_SELECTED: 'Nenhuma solicitação selecionada.',
                        NO_REQUEST_AND_TYPE_SELECTED: 'Selecione a solicitação e o tipo de alteração.',
                        NO_COMPANY_USER_SELECTED: 'Selecione a empresa / pessoa',
                        NO_SERVICE_SELECTED: 'Selecione o serviço',
                        HAS_LICENSE_IN_PROGRESS:
                            'Não é possível solicitar segunda via. Já existe uma solicitação em andamento para esta Licença.',
                        NO_COMPANY_SELECTED: 'Selecione a empresa',
                        INSPECTION_REPORT_SENT: 'Laudo enviado com sucesso!',
                        IRREGULARITY_DELETE_ERROR: 'Erro ao excluir irregularidade. Tente novamente.',
                        MISSING_VEHICLES_DOCS: 'Favor inserir os documentos de todos os veículos para continuar.',
                        NOT_ADD_ELEMENTS_MORE_THAN_ORIGIAL:
                            'Não é possivel adicionar itens além do número de itens da licença origial.',
                        ELEMENT_ALREADY_EXISTS: 'Este item já se encontra na listagem.',
                        FIRST_ELEMENT_ALREADY_EXISTS_TWO_TIMES: 'O munícipio inicial já foi adicionado duas vezes',
                        LAST_ELEMENT_NEEDS_EQUAL_FIRST:
                            'Deverá ser informado o último município com o valor do primeiro município',
                        REMOVE_LAST_ELEMENT_TO_ADD: 'Favor remover o último munícipio para seguir adicionando.',
                        MISSING_PASSANGERS:
                            'Favor incluir um ou mais passageiros na respectiva lista para solicitar licença.',
                        MISSING_INTINERARY:
                            'Favor incluir dois ou mais munícipios na lista de itinerário para solicitar licença.',
                        MISSING_COMPANIES:
                            'Favor incluir um ou mais empresa(s) contratante(s) / órgão(s) na respectiva lista para solicitar licença',
                        MISSING_SCHEDULE:
                            'Favor incluir um ou mais intervalos de horários e dia da semana na respectiva lista para solicitar licença.',
                        MISSING_LINE_SCHEDULE: 'Favor incluir um ou mais horários para enviar solicitação.',
                        SCHEDULE_NOT_BIGGER_EQUAL: 'Horário inicial não pode ser maior ou igual ao horário final.',
                        OVERLAPPING_SCHEDULES: 'Não podem existir horários com sobreprosição',
                        MISSING_VEHICLES: 'Favor incluir um ou mais veículo(s) para solicitar licença.',
                        IRREGULARITIES_ERROR:
                            'Favor verificar as irregularidades. Alguns itens obrigatórios não foram preenchidos.',
                        MISSING_REPORT_TO_SEND:
                            'Existem veículos que não possuem laudo informado para envio. Favor verificar.',
                        ERROR_TO_EXCLUDE: 'Ocorreu um erro ao excluir. Favor tente novamente.',
                        MISSING_SECOND_LINE: 'Selecione a Linha 2 para concluir.',
                        MISSING_LINES_SELECTION: 'O(s) campo(s) sinalizado(s) deve(m) ser preenchido(s).',
                        VEHICLE_ALREADY_EXISTS: 'O veículo de {name} {value} já está cadastrado no sistema.',
                        VEHICLE_ALREADY_LISTED: 'O veículo de {name} {value} já está listado na solicitação.',
                        VEHICLE_ALREADY_REQUESTED:
                            'O veículo de {name} {value} já está associado à solicitação {data}.',
                        INCLUSION_ALREADY_REQUESTED:
                            'Somente é permitido um veículo cadastrado por operador do subsistema Complementar, e já existe a solicitação {data} em andamento.',
                        MAIS_DE_UM_VEICULO_COMPLEMENTAR_LISTADO:
                            'Somente é permitido um veículo cadastrado por operador do subsistema Complementar. Remova os veículos excedentes ou altere o subsistema para continuar.',

                        USER_SUCCESSFULLY_SAVED: 'Usuário salvo com sucesso!',
                        USER_SAVE_BLOCKED_SAME_IDENTIFIER: 'Usuário com o CPF/CNPJ informado já existe.',
                    },
                    WRONG_CHOICE_MISSING_CERTIFICATE:
                        'Este tipo de serviço necessita geração de certificado / licença para aprovação.',
                    WRONG_CHOICE_MISSING_SURVEY_CERTIFICATE:
                        'Este tipo de serviço pode necessitar a geração de certificados para aprovação. Verifique se há certificados a serem adicionados na aba de Certificados.',
                    WRONG_CHOICE_TO_SERVICE_TYPE:
                        'Este tipo de serviço necessita envio de documento para a assinatura. Favor solicitar assinatura na aba Certificados',
                    MISSING_DOCUMENTS_TO_APPROVE:
                        'Todos os documentos obrigatórios precisam ser preenchidos e aprovados para continuar. Certifique-se de ter salvo suas modificações na aba de Documentação e Pendências.',
                    MAX_VEHICLES: 'Você já inseriu o número máximo de veículos permitidos',
                    VEHICLE_MAX_AGE:
                        'O veículo atingiu a idade máxima e não é permitida a sua inclusão. Selecione outro veículo e a exclusão desse veículo do sistema.',
                    VEHICLE_MAX_AGE_ADD: 'O veículo atingiu a idade máxima e não é permitida a sua inclusão.',
                    VEHICLE_UPDATE_ERROR: 'Erro ao atualizar veículo. Tente novamente',
                    PLATE_FOUND: 'Veículo já selecionado anteriormente',
                    VEHICLE_DELETE_ERROR: 'Erro ao excluir veículo.',
                },
                CERTIFICATION: {
                    SUCCESSFUL_SEND: 'Certificado enviado com sucesso!',
                    SUCCESSFUL_SEND_SIGNATURE: 'Certificado enviado para assinatura com sucesso!',
                    SUCCESSFUL_SAVED: 'Certificado gerado com sucesso!',
                    PROBLEM_SENDING: 'Erro ao enviar certificado.',
                    PROBLEM_GET_CERTIFICATES: 'Erro ao carregar certificados.',
                },
                REQUEST: {
                    ADMIN_PENDING_APPROVAL:
                        'Após aprovação do administrador suas solicitações em andamento serão exibidas aqui.',
                    STATUS_REQUEST_MANDATORY: 'Selecione o estado da solicitação antes de finalizar.',
                    PROBLEM_GET_REQUESTS: 'Problemas ao carregar solicitação. Tente novamente.',
                    PROBLEM_GET_SERVICES: 'Problemas ao carregar os serviços. Tente novamente.',
                    REQUEST_REVISION_SENT: 'Solicitação de ajustes enviada com sucesso.',
                    PROBLEM_REVISION_SEND: 'Problemas ao solicitar ajustes. Tente novamente.',
                    REASON_MANDATORY: 'Favor informar a justificativa.',
                },
                FORMS: {
                    IMPORTANT: 'Importante!',
                    ALL_DOCUMENTS_REQUIRED: 'Todos os documentos são obrigatórios.',
                    VERIFY_DOCUMENTS_REQUIRED: 'Documentos obrigatórios estão assinalados.',
                    DOCUMENT_REQUIRED: 'O documento é obrigatório.',
                    COULD_NOT_GET_FORM_SCHEMA: 'Não foi possível buscar o formulário para o serviço.',
                    SUCCESSFUL_SAVED_FORM: 'Formulário salvo com sucesso!',
                    COULD_NOT_SAVE_FORM: 'Ocorreu um erro ao salvar.',
                },
                USER: {
                    PASSWORD_CHANGED: 'Nova senha salva com successo.',
                    COULD_NOT_CHANGE_PASSWORD: 'Não foi possível salvar a senha.',
                    SUCCESSFUL_SAVED_USER: 'Usuário salvo com sucesso.',
                    COULD_NOT_SAVE_USER: 'Ocorreu um erro ao salvar o usuário.',
                },
                WIDGET: {
                    PDF: {
                        COULD_NOT_GET_PDF_FROM_SERVER: 'Não foi possível fazer o download do pdf.',
                    },
                },
                SOMENTE_UM_VEICULO_COMPLEMENTAR:
                    'Somente é permitido um veículo cadastrado por operador do subsistema Complementar.',
            },
        },
    },
});

const appGeneralConfig = { getAppSettings };

export default appGeneralConfig;
